export const C_DEFAULT_SALES_LABEL = 'Gross Receipts';
export const C_DEFAULT_DEDUCTIONS_LABEL = 'Allowable Deductions';
export const C_DEFAULT_TAXABLE_RECEIPTS_LABEL = 'Taxable Receipts';
export const C_DEFAULT_REPORT_REVENUE_SUB_HEADING = 'Taxable Receipts';
export const C_TOT_PAYMENT_STATUS_INCOMPLETE = 'incomplete';
export const C_DEFAULT_TAX_CERTIFICATION =
  'I declare, under penalty of perjury, that to the best of my knowledge and belief, the statements herein are true and correct.';
export const C_LAST_12_MONTHS = 'last_12_months';
export const C_DEFAULT_TRANSLATIONS = {
  registrant: 'Registrant',
  owner: 'Owner',
  property_manager: 'Property Manager',
  local_contact: 'Local Contact',
  tenant: 'Tenant',
};
export const C_PERMIT_STATUS_CURRENT = 'current';
export const C_PERMIT_STATUS_SUBMITTED = 'submitted';
export const C_PERMIT_STATUS_RETURNED = 'returned';
export const C_PERMIT_STATUS_REVIEWED = 'reviewed';

export const C_PERMIT_STATUS_EXPIRED = 'expired';
export const C_PERMIT_STATUS_DENIED = 'denied';
export const C_PERMIT_STATUS_WITHDRAWN = 'withdrawn';
export const C_PERMIT_STATUS_REVOKED = 'revoked';
export const C_PERMIT_STATUS_SUSPENDED = 'suspended';

export const C_ACTIVE_PERMIT_STATUSES = [
  C_PERMIT_STATUS_CURRENT,
  C_PERMIT_STATUS_SUBMITTED,
  C_PERMIT_STATUS_RETURNED,
  C_PERMIT_STATUS_REVIEWED,
];

export const C_INACTIVE_PERMIT_STATUSES = [
  C_PERMIT_STATUS_EXPIRED,
  C_PERMIT_STATUS_DENIED,
  C_PERMIT_STATUS_WITHDRAWN,
  C_PERMIT_STATUS_REVOKED,
  C_PERMIT_STATUS_SUSPENDED,
];

export const C_DASHBOARD_CONTENT_SECTION_HEIGHT = 520;

export const C_RENEWAL_STATUS_SUBMITTED = 'submitted';

export const C_DEFAULT_UPDATE_CERTIFICATION =
  'I certify under penalty of perjury that this information is accurate and I am an authorized representative or owner of this business. I acknowledge that my signature is legally binding.';
export const C_DEFAULT_RENEW_CERTIFICATION =
  'I certify under penalty of perjury that this information is accurate and I am an authorized representative or owner of this business. I acknowledge that my signature is legally binding.';

export const LTRText = 'Long-Term Rental';
export const STRText = 'Short-Term Rentals';

export enum RentalType {
  STR = 'str',
  LTR = 'ltr',
}

export const US_STATES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
  DC: 'District of Columbia',
  AS: 'American Samoa',
  GU: 'Guam',
  MP: 'Northern Mariana Islands',
  PR: 'Puerto Rico',
  UM: 'United States Minor Outlying Islands',
  VI: 'Virgin Islands, U.S.',
};
